import { memo } from "react";

import { QuestionSalesTermWithTime } from "@/components/features/items/edit/_shared/ui/components/main/questions/sales-term-with-time";

import { useDayTripPlanSaleTerm } from "./hooks";

export const QuestionDayTripPlanSaleTerm = memo(() => {
	const {
		isEdited,
		hasError,

		isLimitedSale,

		saleTypeForTerm,
		onSetSaleTypeForTerm,
		saleTypeForTermOptions,

		saleStart,
		saleEnd,
		saleStartTime,
		saleEndTime,
		onSetSaleTermWithTime,

		stayableStart,
		stayableEnd,
		onSetStayableTerm,
	} = useDayTripPlanSaleTerm();

	return (
		<QuestionSalesTermWithTime
			isEdited={isEdited}
			hasError={hasError}
			isLimitedSale={isLimitedSale}
			saleTypeForTerm={saleTypeForTerm}
			saleTypeForTermOptions={saleTypeForTermOptions}
			onSetSaleTypeForTerm={onSetSaleTypeForTerm}
			saleStart={saleStart}
			saleEnd={saleEnd}
			saleStartTime={saleStartTime}
			saleEndTime={saleEndTime}
			onSetSaleTermWithTime={onSetSaleTermWithTime}
			stayableStart={stayableStart}
			stayableEnd={stayableEnd}
			onSetStayableTerm={onSetStayableTerm}
		/>
	);
});

QuestionDayTripPlanSaleTerm.displayName = "QuestionDayTripPlanSaleTerm";
